<template>
  <ion-page>
  <master-layout pageTitle="سفارشات">
    <ion-card-content>
      <router-link to="/Order/Add" class="btn btn-success">افزودن سفارش جدید</router-link>
      <ion-grid>
        <ion-row>

          <ion-col size="6">
            <MainPageItem :amount="raw_count" icon="clipboard-list" itemTitle="سفارشات خام" url="/order/list?st=0"></MainPageItem>
          </ion-col>

          <ion-col size="6">
            <MainPageItem :amount="done_count" icon="clipboard-check" itemTitle="سفارشات انجام شده" url="/order/list?st=1"></MainPageItem>
          </ion-col>

          <ion-col size="6">
            <MainPageItem :amount="pay_count" icon="wallet" itemTitle="سفارشات پرداخت شده" url="/order/list?st=2"></MainPageItem>
          </ion-col>

          <ion-col size="6">
            <MainPageItem :amount="debt_count" icon="hand-holding-usd" itemTitle="سفارشات مانده بدهی" url="/order/list?st=3"></MainPageItem>
          </ion-col>

        </ion-row>
      </ion-grid>

    </ion-card-content>
  </master-layout>
  </ion-page>
</template>


<script>

import MainPageItem from '/src/components/MainPageItem'
import {
  IonCardContent, IonGrid, IonCol, IonRow,IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
// this.$route.query.st

export default {
  components: {
    IonCardContent, IonGrid, IonCol, IonRow,IonPage,MainPageItem
  },data(){
    return {
      debt_count : '0',
      pay_count : '0',
      done_count : '0',
      raw_count : '0'
    }
  },
  async mounted()
  {
    let info = await this.numberOfOrder();
    if (info.ok)
    {
      this.pay_count = info.pay_count;
      this.debt_count = info.debt_count;
      this.done_count = info.done_count;
      this.raw_count = info.raw_count;
    }
  }
  ,methods:{
    ...mapActions("order", {
      numberOfOrder: 'numberOfOrder',
    }),
  }
};
</script>

<style scoped>

</style>